import { useState } from 'react';
import PropTypes from 'prop-types';
import Loader from 'modules/common/components/LoaderV2';
import { addService } from 'modules/categories/api';
import { status } from 'constants/general';

import { getServicesTypes, ServiceTypeEnum } from 'constants/categories';
import { useSelector } from 'react-redux';
import { selectedHealthPlanCountrySelector } from 'modules/healthPlans/healthPlansSlice';
import {
  InputBasicField,
  InputFieldWrapper,
  ItemContainer,
  ItemName,
  ItemWrapper,
  ServiceTypeSelect,
  extendLoaderStyle,
} from './AddPricelistServicesModal.style';

const ServiceRecord = ({
  serviceName,
  serviceKey,
  priceListId,
  servicePrevPrice,
  servicePrevType,
  allowEditType,
}) => {
  const [submittionStatus, setSubmittionStatus] = useState(status.SHOULD_CALL_API);
  const [inputValue, setInputValue] = useState(servicePrevPrice);
  const selectedHealthPlanCountry = useSelector(selectedHealthPlanCountrySelector);
  const servicesTypes = getServicesTypes(selectedHealthPlanCountry?.currency?.name);
  const [inputType, setInputType] = useState(
    servicesTypes[servicePrevType || ServiceTypeEnum.Fixed].value,
  );

  const onSave = (inputValue, inputType) => {
    if (!inputType || !inputValue) return;
    if (`${inputType}` === `${ServiceTypeEnum.Percentage}` && inputValue > 100) {
      setSubmittionStatus(status.FAIL);
      return;
    }
    setSubmittionStatus(status.SUBMITING);
    const payload = {
      priceListId: Number(priceListId),
      priceListConfiguration: {
        productKey: serviceKey,
        productName: serviceName,
        priceValue: Number(inputValue),
        discountType: Number(inputType),
      },
    };
    addService(payload)
      .then(() => {
        setSubmittionStatus(status.SUCCESS);
      })
      .catch(() => {
        setSubmittionStatus(status.FAIL);
      });
  };

  const handleFocusOut = () => {
    if (`${inputValue}`?.length && `${inputValue}`.trim() !== '' && inputType) {
      onSave(inputValue, inputType);
    }
  };

  return (
    <ItemContainer key={serviceKey}>
      <ItemWrapper>
        <ItemName>{serviceName}</ItemName>
      </ItemWrapper>
      <ItemWrapper
        style={{
          height: '40px',
          padding: '6px 13px',
          width: '90%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <InputFieldWrapper onBlur={handleFocusOut}>
            <InputBasicField
              type="number"
              value={inputValue}
              placeholder="0"
              onChange={e => setInputValue(e.target.value)}
            />
            <ServiceTypeSelect
              disabled={!allowEditType}
              value={inputType}
              onChange={e => setInputType(e.target.value)}
            >
              {Object.values(servicesTypes).map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </ServiceTypeSelect>
          </InputFieldWrapper>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            {submittionStatus === status.SUBMITING && <Loader extendStyle={extendLoaderStyle} />}
            {submittionStatus === status.SUCCESS && <p style={{ color: '#31A636' }}>Successeded</p>}
            {submittionStatus === status.FAIL && <p style={{ color: '#DB3226' }}>Failed</p>}
          </div>
        </div>
      </ItemWrapper>
    </ItemContainer>
  );
};

ServiceRecord.propTypes = {
  serviceName: PropTypes.string.isRequired,
  serviceKey: PropTypes.string.isRequired,
  priceListId: PropTypes.string.isRequired,
};

export default ServiceRecord;
